<template>
  <div class="app-container" :style="appContainerStyle">
    <template v-if="$store.state.auth.canRenderDefaultLayout">
      <navbar />
      <div class="app-content position-relative h-100">
        <sidebar-drawer v-if="isShowMenu" :active-menu="l2Menu" :menus="showMenus" :staredMenus="staredMenus" @routerChange="onRouterChange" />
        <l2-menu :l2-menu="l2Menu" v-if="isShowMenu && (menuList.length || staredMenus.length)" :staredMenus="staredMenus" :menuShow="showMenuList" :hasMenuListShow="hasMenuListShow" :menuList="menuList" @routerChange="onRouterChange" />
        <div
          id="app-page"
          :key="'app-page-' + (isShowMenu && l2MenuVisibleForStore && showMenuList && (menuList.length || staredMenus.length))"
          :class="appPageClass">
          <div :style="appPageWrapperStyle">
            <top-alert />
            <div class="app-page-content">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="h-100 d-flex align-items-center justify-content-center">
        <a-spin />
      </div>
    </template>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import storage from '@/utils/storage'
import Navbar from '@scope/layouts/Navbar'
import TopAlert from '@/sections/TopAlert'
import { hasPermission } from '@/utils/auth'
import { menusConfig } from '@/router/routes'
import L2Menu from '../Sidebar/Menu'
import SidebarDrawer from '../Sidebar/Drawer'

export default {
  name: 'DefaultLayout',
  components: {
    SidebarDrawer,
    Navbar,
    TopAlert,
    'l2-menu': L2Menu,
  },
  data () {
    return {
      l2MenuVisible: false,
      l2Menu: {},
      menuitems: menusConfig,
      showMenuList: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState('common', {
      staredList: state => state.sidebar.staredList,
      openCloudShell: state => state.openCloudShell,
      cloudShellHeight: state => state.cloudShellHeight,
    }),
    appPageWrapperStyle () {
      const style = {
        flex: '1 1 100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }
      return style
    },
    appContainerStyle () {
      if (this.openCloudShell) {
        return {
          maxHeight: `calc(100% - ${this.cloudShellHeight}px)`,
          flex: '1 1 auto',
        }
      }
      return {}
    },
    menus () {
      // bill 等路由 meta.hidden 内用 import store + hasSetupKey，与组件计算属性无自动依赖；此处显式订阅，保证 setupKeys / 视图模式 / 策略变更时一级菜单重算
      this.touchMenuHiddenReactiveDeps()
      const ret = this.menuitems.filter(m1item => {
        let flag = false
        if (this.showMenu(m1item)) {
          if (m1item.menus) {
            m1item.menus.forEach(m2item => {
              if (this.showMenu(m2item)) {
                if (m2item.submenus) {
                  m2item.submenus.forEach(m3item => {
                    if (this.showMenu(m3item)) {
                      flag = true
                    }
                  })
                } else {
                  flag = true
                }
              }
            })
          } else {
            flag = true
          }
        }
        return flag
      })
      return ret
    },
    showMenus () {
      return this.menus
    },
    staredMenus () {
      const ls = this.showMenus
      const list = []
      ls.map(item => {
        if (item.menus) {
          item.menus.map(menu => {
            if (menu.submenus) {
              menu.submenus.map(submenu => {
                if (this.staredList.includes(submenu.path)) {
                  list.push({
                    title: this.getLabel(submenu.meta),
                    path: submenu.path,
                  })
                }
              })
            }
          })
        }
      })
      list.sort((a, b) => {
        const aIdx = this.staredList.indexOf(a.path)
        const bIdx = this.staredList.indexOf(b.path)
        return aIdx - bIdx
      })
      return list
    },
    allMenuList () {
      const ls = this.showMenus
      const list = []
      ls.map(item => {
        if (item.menus) {
          item.menus.map(menu => {
            if (menu.submenus && menu.submenus.length) {
              list.push(menu)
            }
          })
        }
      })
      return list
    },
    allList () {
      const list = []
      this.allMenuList.forEach(item => {
        if (item.submenus) {
          item.submenus.forEach(submenu => {
            list.push({ ...submenu, subGroup: item.subGroup })
          })
        }
      })
      return list
    },
    currentMenu () {
      let routePath = this.$route.path
      if (routePath.endsWith('/')) {
        routePath = routePath.slice(0, -1)
      }
      const target = this.allList.filter(item => {
        if (item.path === routePath) {
          return true
        }
        if (item.children && item.children.length && item.children.some(child => child.path && `${item.path}/${child.path}` === routePath)) {
          return true
        }
        return false
      })
      if (target.length) {
        return target[0]
      }
      return null
    },
    menuList () {
      this.touchMenuHiddenReactiveDeps()
      if (this.currentMenu && this.currentMenu.subGroup) {
        const target = this.allMenuList.filter(item => item.subGroup === this.currentMenu.subGroup)
        const list = []
        target.forEach(item => {
          if (item.submenus) {
            item.submenus = item.submenus.filter(submenu => {
              const isHidden = this.getMenuHidden(submenu)
              const isPermission = submenu.meta?.permission ? hasPermission({ key: submenu.meta.permission }) : true
              return !isHidden && isPermission
            })
            if (item.submenus.length) {
              list.push(item)
            }
          }
        })
        return list
      }
      return []
    },
    isShowMenu () {
      const { globalSetting } = this.$store.state
      if (!globalSetting || (globalSetting && !globalSetting.value) || (globalSetting.value && !globalSetting.value.key)) {
        return true
      }
      return globalSetting.value.key.length > 0
    },
    l2MenuVisibleForStore () {
      return this.$store.state.setting.l2MenuVisible
    },
    hasMenuListShow () {
      return this.staredMenus.length || this.menuList.length
    },
    appPageClass () {
      if (this.isShowMenu && this.l2MenuVisibleForStore && this.showMenuList && (this.menuList.length || this.staredMenus.length)) {
        return 'app-page l2-menu-show h-100'
      }
      return 'app-page h-100'
    },
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        const newParentPath = val.matched[0] && val.matched[0].path
        const oldParentPath = oldVal && oldVal.matched && oldVal.matched[0] && oldVal.matched[0].path
        if (newParentPath !== oldParentPath) {
          const firstMatched = val.matched[0]
          for (let i = 0, len = this.menuitems.length; i < len; i++) {
            const item = this.menuitems[i]
            if (item.meta.group === firstMatched.meta.group) {
              this.l2Menu = item
              let l2MenuVisible = false
              if (item.menus) {
                l2MenuVisible = true
              }
              this.l2MenuVisible = l2MenuVisible
              break
            } else {
              this.l2Menu = {}
              this.l2MenuVisible = false
            }
          }
        }
      },
      immediate: true,
    },
    hasMenuListShow: {
      handler (val, oldVal) {
        this.showMenuList = !!val
        // if (!val && oldVal) {
        //   this.$store.commit('setting/SET_L2_MENU_VISIBLE', false)
        // }
        // if (val && !oldVal) {
        //   this.$store.commit('setting/SET_L2_MENU_VISIBLE', true)
        // }
      },
    },
  },
  methods: {
    touchMenuHiddenReactiveDeps () {
      // 依次读取以挂到 menus/menuList 计算属性的响应式依赖（不用 void，避免 no-void）
      const subscriptions = [
        this.userInfo,
        this.$store.getters.isAdminMode,
        this.$store.getters.isDomainMode,
        this.$store.getters.isProjectMode,
        this.$store.getters.scopedPolicy,
        this.$store.state.globalSetting?.value?.setupKeys,
      ]
      return subscriptions.length
    },
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    getMenuHidden (menu) {
      if (!R.isNil(menu.meta.hidden)) {
        if (R.is(Function, menu.meta.hidden)) {
          return menu.meta.hidden(this.userInfo, menu)
        }
        return menu.meta.hidden
      }
      if (!R.isNil(menu.meta.invisible)) {
        if (R.is(Function, menu.meta.invisible)) {
          return menu.meta.invisible(this.userInfo, menu)
        }
        return menu.meta.invisible
      }
      return false
    },
    showMenu (item) {
      const hidden = this.getMenuHidden(item)
      if (R.isNil(item.meta.permission) || R.isEmpty(item.meta.permission)) {
        return !hidden && true
      }
      return !hidden && hasPermission({ key: item.meta.permission })
    },
    onRouterChange (menu, ignoreJump = false) {
      if (!ignoreJump) {
        this.$router.push(menu.path)
      }
      let menus = this.$store.getters.common.sidebar.recentList.filter(item => item)
      const index = R.findIndex(R.propEq('path', menu))(menus)
      if (index !== -1) {
        menus = R.remove(index, 1, menus)
      }
      menus = R.prepend(menu.path, menus)
      if (menus.length > 6) {
        menus = R.slice(0, 6, menus)
      }
      storage.set('__oc_recent_visit__', menus)
      this.$store.dispatch('common/updateObject', {
        name: 'sidebar',
        data: {
          recentList: menus,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.app-content {
  padding-top: 60px;
  display: flex;
  flex-direction: column;
}
.app-page {
  // margin-bottom: 74px;
  padding: 15px 15px 0 15px;
  &.l2-menu-show {
    margin-left: 160px !important;
  }
  overflow: auto;
}
.app-page-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  // height: 100%;
}
</style>
